import { twMerge } from 'tailwind-merge';
import { LiliLinkSize, LiliLinkType } from './LiliLink.types';

export const getLinkStyle = (type: LiliLinkType = LiliLinkType.DEFAULT) => {
  switch (type) {
    case LiliLinkType.DEFAULT:
      return 'underline text-text-brand-primary hover:text-text-brand-primary-hover';
    case LiliLinkType.QUIET:
      return 'text-text-brand-primary hover:text-text-brand-primary-hover';
    case LiliLinkType.SMART:
      return 'text-text-brand-primary hover:text-text-brand-primary-hover py-[4px] px-[10px] hover:bg-surface-brand-action-00 rounded-[4px]';
    case LiliLinkType.SECONDARY:
      return 'hover:underline text-text-main-secondary hover:text-text-main-primary';
    case LiliLinkType.SECONDARY_QUITE:
      return 'text-text-main-secondary hover:text-text-main-primary';
  }
};

export const getLinkSize = (size: LiliLinkSize = LiliLinkSize.MEDIUM) => {
  switch (size) {
    case LiliLinkSize.SMALL:
      return `text-[14px] leading-[16px]`;
    case LiliLinkSize.MEDIUM:
      return `text-[16px] leading-[24px]`;
  }
};

export const getLinkClassName = (
  type: LiliLinkType,
  size: LiliLinkSize,
  fontClass: string,
  className?: string
) =>
  twMerge(
    'flex gap-[2px] items-center',
    fontClass,
    getLinkStyle(type),
    getLinkSize(size),
    'cursor-pointer',
    className
  );
